<template>
  <div>
    <div class="vx-row">
      <!-- All Employees Switch -->
      <div class="vx-col sm:w-1/6 w-full md:mt-8 mb-6">
        <div class="demo-alignment">
          <span class="mr-4">All Employee</span>
          <div class="flex">
            <vs-switch v-model="uploadSwitch">All Employees</vs-switch>
          </div>
        </div>
      </div>

      <!-- Employee Code -->
      <div class="vx-col sm:w-2/12 w-full mb-2" v-show="!uploadSwitch">
        <span class="text-sm">Please Select Employee</span> <span>*</span>
        <v-select
          v-model="selectedUser"
          v-validate="'required'"
          class="w-full"
          name="Users"
          label="fullName"
          :options="getusers"
          placeholder="Please Select"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-2/12 w-full mb-2">
        <span class="text-sm">Calendar Year</span
        ><span style="color: red">*</span>
        <v-select
          v-validate="'required'"
          name="calendar_year"
          label="year"
          :reduce="(yearObj) => yearObj.year"
          v-model="calendarYear"
          :options="getYearsLookup"
          class="w-full"
        />
      </div>
    </div>
    <div class="flex justify-between flex-wrap mt-5 pt-20">
      <span />
      <vs-button
        @click="onGenerateBIR()"
        color="success"
        type="filled"
        icon-pack="feather"
        icon="icon-download"
        >Generate Reports</vs-button
      >
    </div>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";

import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";
import axios from "@/axios.js";
export default {
  data() {
    return {
      calendarYear: null,
      uploadSwitch: true,
      selectedUser: null,
      years: [],
    };
  },
  async created() {
    try {
      // load payroll data
      const response = await this.$store.dispatch(
        "payroll/getAllCreatePayroll"
      );
      const allData =
        response.data && response.data.data
          ? response.data.data
          : response.data || [];
      if (Array.isArray(allData) && allData.length > 0) {
        const years = [...new Set(allData.map((p) => Number(p.calendarYear)))];
        this.years = years.sort((a, b) => b - a);
      }

      // load employees (with loader)
      await this.loadEmployees();
    } catch (error) {
      console.error("Error loading payroll or employees:", error);
    }
  },

  computed: {
    getYearsLookup() {
      return this.years.map((y) => ({ year: y }));
    },
    tenantName() {
      return (id) => this.$store.getters["tenants/tenantName"](id);
    },
    getusers() {
      return this.$store.state.hrms.allEmployee;
    },
  },
  components: {
    "v-select": vSelect,
  },
  methods: {
    async loadEmployees() {
      try {
        if (
          !this.$store.state.hrms.allEmployee ||
          this.$store.state.hrms.allEmployee.length === 0
        ) {
          this.$vs.loading({
            type: "square",
            text: "Loading employee data...",
          });
          const data = { pageNumber: -1, pageSize: -1 };
          await this.$store.dispatch("hrms/getAllEmployee", data);
        }
      } catch (error) {
        console.error("Error loading employees:", error);
        this.$alert("Failed to load employee data.", "Error", "error");
      } finally {
        this.$vs.loading.close();
      }
    },
    onGenerateBIR() {
      this.$vs.loading();
      var logoPath = "";
      let tenant = this.tenantName(this.$store.state.AppActiveUser.tenantsId);
      var pDate = moment(new Date()).format("YYYYMMDD");

      if (tenant.photoId != null) {
        this.$store
          .dispatch("getFile", tenant.photoId) //Get filePath of Company Logo
          .then((response) => {
            logoPath = response.data.path;
          });
      }
      if (!this.calendarYear) {
        this.$alert(
          "Please select a Calendar Year first.",
          "Validation Error",
          "warning"
        );
        this.$vs.loading.close();
        return;
      }
      if (!this.uploadSwitch && (!this.selectedUser || !this.selectedUser.id)) {
        this.$alert(
          "Please select an Employee first.",
          "Validation Error",
          "warning"
        );
        this.$vs.loading.close();
        return;
      }

      const reportName = this.uploadSwitch ? "BIR2316ALL" : "BIR2316";
      const today = new Date();
      const yyyyMMdd = today.toISOString().slice(0, 10).replace(/-/g, "");

      const data = {
        serverName: tenant.secretKey,
        dbName: tenant.apiKey,
        userName: "",
        password: "",
        companyCode: tenant.code,
        companyName: tenant.name,
        address: tenant.address,
        photoURL: logoPath,
        createPayrollId: 0, //this.createPayroll.createPayrollId,
        printedBy: this.$store.state.AppActiveUser.uid,
        reportName: [reportName], //['PayrollSummary', 'PayrollEarnings'],
        payOutDate: pDate, //moment(this.createPayroll.payOutDate).format('YYYYMMDD'),
        creditDate: pDate,
        passwordToOpen: null,
        monthName: "",
        yearScope: this.calendarYear,
        reportType: reportName,
        userId: this.uploadSwitch
          ? [this.$store.state.AppActiveUser.uid]
          : [this.selectedUser ? this.selectedUser.id : null],
      };

      // this.$vs.loading()
      this.$store.dispatch("payroll/GenerateReports", data).then(() => {
        const zipFileName = `${tenant.code}_${reportName}.zip`;
        let queryParam = "";
        if (reportName === "BIR2316ALL") {
          queryParam = `${this.calendarYear}`;
        } else {
          queryParam = `${yyyyMMdd}`;
        }

        axios
          .get(
            `/api/reports/DownloadFile?dbName=${tenant.code}&fileName=${zipFileName}&payOutDate=${queryParam}&reportType=${reportName}`,
            { reportProgress: true, responseType: "blob" }
          )
          .then((response) => {
            this.$vs.loading.close();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", zipFileName);
            document.body.appendChild(link);
            link.click();

            Swal.fire({
              title: "Done",
              html: "BIR 2316 Reports Generated",
              icon: "success",
            });
          })
          .catch((error) => {
            this.$vs.loading.close();
            this.$alert(error.message, "Error", "error");
          });
      });
    },
  },
};
</script>
